import React, { ReactNode } from 'react'
import styled from 'styled-components'


const StyledButton = styled.button`
    cursor: pointer;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    text-decoration: none;
    color: #fff;
    padding: 12px 40px;
    border-radius: 64px;
    transition: all .5s cubic-bezier(0,0,.23,1);
    background-color: #0083FF;
    border-color: #0083FF;
    &:hover {
        background-color: #1878D2;
    }
`;

interface ButtonPrimaryProps {
    text: string;
    functionx: Function;
  }

const ButtonPrimary: React.FC<ButtonPrimaryProps> = ({ functionx, text }) => {
    return (
      <StyledButton onClick={() => functionx()}>{text}</StyledButton>
    );
  }

export default ButtonPrimary
